import React from 'react';
import classnames from 'classnames';

import epochs from '~/kits/general/config';

export default ({ activeEpochId, xScale }) => {

  return (
    <div className="epochbars">
      {epochs.map((epoch, index) => {
        const startX = xScale(epoch.startDate);
        const endX = xScale(epoch.endDate);
        const gapSize = index === epochs.length -1 ? 0 : 5;
        const width = endX - startX - gapSize;
        const active = activeEpochId === epoch.id;
        const itemClasses = classnames('epochbars__item', { active })

        return (
          <div
            className={itemClasses}
            key={epoch.id}
            style={{ width: width, left: startX }}
          >
            <div className="epochbars__item-bar" />
            <div className="epochbars__item-title">{epoch.title}</div>
            <div className="epochbars__item-description">{epoch.description}</div>
          </div>
        );
      })}
    </div>
  );
};


